import React, { Component } from "react";
import { connect } from "react-redux";

import MovieTheater from './containers/movietheater.component';
import MovieTheaterDetails from './containers/movietheatersdetails.component';
import { requestMovieTheaters, getMovieTheatersSeeMore } from '../../../SHARED/actions/movietheaters.actions';
import MapWithContainer from "../../../SHARED/components/maps/mapwithcontainer";
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import { pageViewEvent, slugify } from "../../../SHARED/helpers/general.helper";
import { Helmet } from "react-helmet";
import { storeSelectedCinemaLocation } from "../../../SHARED/actions/filters.actions";
import { API_URL } from '../../../SHARED/config/apiEndpoints';
class MovieTheaters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMap: false,
            selectedCinema: {}
        };
    }

    componentWillMount() {
        window.prerenderReady = false;
        if(slugify(this.props.selectedCinemaLocation)!== slugify(this.props.match.params.slug)){
            const params_slug = slugify(this.props.match.params.slug);
            this.props.storeSelectedCinemaLocation(this.props.cinemaLocations.find((value)=>slugify(value.locality_name) === params_slug).locality_name)
        } else {
            this.props.requestMovieTheaters(0);
        }
        window.scrollTo(0, 0);
    }

    componentDidMount(){
        pageViewEvent(`Filme Cinema azi ${this.props.selectedCinemaLocation}`,`/cinematografe/${slugify(this.props.selectedCinemaLocation)}`)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.selectedCinemaLocation !== nextProps.selectedCinemaLocation) {
            this.props.history.push('/cinematografe/' + slugify(nextProps.selectedCinemaLocation));
            pageViewEvent(`Filme Cinema azi ${this.props.selectedCinemaLocation}`,`/cinematografe/${slugify(this.props.selectedCinemaLocation)}`)
            this.props.requestMovieTheaters(0);
            window.scrollTo(0, 0);
        }
        if(!window.prerenderReady && nextProps.paginatedData ){
            this.handleLoad();
        }

    }

    handleLoad() {
        window.prerenderReady = true;
     }

    getCinemaImagesURL(defaultImage, images) {
        let cinemaImagesURL = [];
        if (images.length !== 0) {
            cinemaImagesURL.push({ article_image: defaultImage });
            images.forEach(imageURL => {
                cinemaImagesURL.push({ article_image: imageURL });
            });
        }
        else if (defaultImage) {
            cinemaImagesURL.push({ article_image: defaultImage });
        }

        return cinemaImagesURL;
    }

    navigateToSchedule(movieTheater) {
        const path = '/program/' + movieTheater.movieTheater.cinema_id + '/' + slugify(movieTheater.movieTheater.cinema_name);
        this.props.history.push(path);
    }

    showMap(item) {
        this.setState({
            showMap: true,
            selectedCinema: item.movieTheater
        });
    }

    hideMap() {
        this.setState({
            showMap: false
        });
    }

    showMovieTheaters(movieTheater) {
        return (
            <div key={movieTheater.cinema_id} className="movie-theater-container row no-gutters">
                <div className="col-lg-4 col-xl-4">
                    <MovieTheater images={this.getCinemaImagesURL(movieTheater.cinema_image, movieTheater.cinema_image_gallery)} />
                </div>
                <div className="col-lg-8 col-xl-8">
                    <MovieTheaterDetails
                        id={movieTheater.cinema_id}
                        uuid={movieTheater.cinema_uuid}
                        name={movieTheater.cinema_name}
                        address={movieTheater.cinema_address_street + ', ' + movieTheater.cinema_address_locality}
                        halls={movieTheater.cinema_nr_of_rooms}
                        phone={movieTheater.cinema_telephone}
                        email={movieTheater.cinema_email}
                        site={movieTheater.cinema_website}
                        favorite={movieTheater.favorite}
                        description={movieTheater.cinema_description}
                        showMap={this.showMap.bind(this, { movieTheater })}
                    />
                </div>

                <div className="col-lg-12 text-right">
                    <button className="movie-schedule" onClick={this.navigateToSchedule.bind(this, { movieTheater })}>VEZI PROGRAMUL FILMELOR</button>
                </div>
            </div>
        );
    }

    seeMore = () => {
        this.props.getMovieTheatersSeeMore(this.props.paginatedData.pager.current_page + 1);
    }

    getSeeMoreCondition = () => {
        if (this.props.paginatedData) {
            if (this.props.paginatedData.rows && this.props.paginatedData.pager) {
                return <span onClick={this.seeMore}>
                    {this.props.paginatedData.rows.length !== this.props.paginatedData.pager.total_items ? "Vezi mai multe..." : ""}
                </span>
            }
        }
    }

    render() {
        return (
            <div className="movie-theaters-container">
                {this.props.loading !== 0 ? <Spinner /> : ''}
                <Helmet>
                    <title>{`Filme Cinema azi ${this.props.selectedCinemaLocation}`}</title>
                    <meta name="description" content={`Vezi cele mai noi filme în cinematografele din ${this.props.selectedCinemaLocation}. Drame, comedii, thriller, SF și de dragoste.`} />
                    <link rel='canonical' href={window.location.href}/>
                    
                    <meta property="og:url"                content={window.location.href} />
                    <meta property="og:type"               content="website" />
                    <meta property="og:title"              content={`Filme Cinema azi ${this.props.selectedCinemaLocation}`} />
                    <meta property="og:description"        content={`Vezi cele mai noi filme în cinematografele din ${this.props.selectedCinemaLocation}. Drame, comedii, thriller, SF și de dragoste.`} />
                    <meta property="og:image"              content={this.props.paginatedData && API_URL + this.props.paginatedData.rows[0].cinema_image} />

                    <meta name="twitter:card" content="summary" />
                    <meta name="twitter:site" content={window.location.href} />
                    <meta name="twitter:title" content={`Filme Cinema azi ${this.props.selectedCinemaLocation}`} />
                    <meta name="twitter:description" content={`Vezi cele mai noi filme în cinematografele din ${this.props.selectedCinemaLocation}. Drame, comedii, thriller, SF și de dragoste.`} />
                    <meta name="twitter:image" content={this.props.paginatedData && API_URL + this.props.paginatedData.rows[0].cinema_image} />
                </Helmet>
                <h1><span className="title">{`CINEMATOGRAFE ÎN ${this.props.selectedCinemaLocation.toUpperCase()}`}</span></h1>
                {this.props.paginatedData && this.props.paginatedData.rows.map(this.showMovieTheaters, this)}
                <div className="col see-more">
                    {this.getSeeMoreCondition()}
                </div>
                <div className="pagination-container row">
                    {this.props.paginatedData && this.props.paginatedData.rows && this.props.paginatedData.rows.length === 0 && <div className="schedule-no-results">Fara rezultate</div>}
                </div>
                {this.state.showMap && <MapWithContainer
                    coordinates={this.state.selectedCinema.cinema_geolocation}
                    title={this.state.selectedCinema.cinema_name}
                    address={this.state.selectedCinema.cinema_address_street + ', ' + this.state.selectedCinema.cinema_address_locality + ', ' + this.state.selectedCinema.cinema_address_postal_code}
                    phone={this.state.selectedCinema.cinema_telephone}
                    closeMap={this.hideMap.bind(this)}
                />}
            </div >
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    paginatedData: state.movieTheaters.paginatedData,
    selectedCinemaLocation: state.filters.selectedCinemaLocation
});

export default connect(mapStateToProps, { storeSelectedCinemaLocation, requestMovieTheaters, getMovieTheatersSeeMore })(MovieTheaters);


// WEBPACK FOOTER //
// ./src/FO/components/movietheaters/movietheaters.component.js